import {
  Bike,
  BookOpen,
  CircleHelp,
  CircleParking,
  ExternalLink,
  Heart,
  House,
  type LucideIcon,
  Map,
  MapPin,
  Phone,
  FileText,
  Wifi,
} from "lucide-react";

export const SHORTCUT_NAME_MAX_LENGTH = 50;
export const DEFAULT_SHORTCUT_ICON_ID = "link";

/** Stable icon IDs stored in `iconId`; the same list is used by guesteria-mobile. */
export const SHORTCUT_ICONS: Record<string, LucideIcon> = {
  heart: Heart,
  house: House,
  location: MapPin,
  phone: Phone,
  document: FileText,
  wifi: Wifi,
  book: BookOpen,
  map: Map,
  activity: Bike,
  help: CircleHelp,
  parking: CircleParking,
  [DEFAULT_SHORTCUT_ICON_ID]: ExternalLink,
};

export const SHORTCUT_ICON_IDS = Object.keys(SHORTCUT_ICONS);

// Fixed shortcut types are stored by name without an iconId; guesteria-mobile opens a screen by
// the name. Key order is the order of the Add Shortcut list.
const FIXED_SHORTCUT_ICON_IDS: Record<string, string> = {
  "Hotel Policy": "book",
  "Wi-Fi": "wifi",
  "Special Services": "house",
  "Hotel Amenities": "map",
  Activities: "activity",
  FAQs: "help",
  Parking: "parking",
};

export const FIXED_SHORTCUT_NAMES = Object.keys(FIXED_SHORTCUT_ICON_IDS);

/** Missing, empty or unknown iconId gives the icon of a fixed type by name, else the default. */
export const resolveShortcutIconId = (
  iconId?: string | null,
  name?: string | null,
): string => {
  if (iconId && Object.prototype.hasOwnProperty.call(SHORTCUT_ICONS, iconId))
    return iconId;
  if (
    name &&
    Object.prototype.hasOwnProperty.call(FIXED_SHORTCUT_ICON_IDS, name)
  ) {
    return FIXED_SHORTCUT_ICON_IDS[name];
  }
  return DEFAULT_SHORTCUT_ICON_ID;
};

export const getShortcutIcon = (
  iconId?: string | null,
  name?: string | null,
): LucideIcon => SHORTCUT_ICONS[resolveShortcutIconId(iconId, name)];

export type ShortcutNameError = "required" | "tooLong" | null;

export const validateShortcutName = (name: string): ShortcutNameError => {
  const trimmed = name.trim();
  if (!trimmed) return "required";
  if (trimmed.length > SHORTCUT_NAME_MAX_LENGTH) return "tooLong";
  return null;
};
